import AboutPageSections from 'features/AboutPage'

const AboutPage = () => {
  return (
    <AboutPageSections />
  )
}

export default AboutPage